import { render } from "./card-transfer.vue?vue&type=template&id=5e291d5c&scoped=true&ts=true"
import script from "./card-transfer.vue?vue&type=script&lang=ts"
export * from "./card-transfer.vue?vue&type=script&lang=ts"

import "./card-transfer.vue?vue&type=style&index=0&id=5e291d5c&lang=less&scoped=true"
import "./card-transfer.vue?vue&type=style&index=1&id=5e291d5c&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e291d5c"]])

export default __exports__